module.exports = __webpack_public_path__ + "img/UA.5ffbe334.svg";